module.exports = __webpack_public_path__ + "static/media/YM18_1.8023beb5.jpg";